import React, { useEffect, useState } from 'react'
import { Input, Label } from '../../../styles/newStyles/Register.styled'
import Text from '../../../core/utils/Text'
import { Link, useNavigate } from 'react-router-dom'
import OTPInput from '../../../components/common/OtpInput'
import SetPasswordForm from '../components/SetPasswordForm'
import { usePassword } from '../core/usePassword'
import { IoEye, IoEyeOff } from 'react-icons/io5'

const AuthOtpPage = ({
    inputValues,
    otpInputRef,
    verifyCode,
    onVerifyCodeChange,
    timer,
    onOtpResend,
    verifyData,
    authCode,
    setAuthCode,
    password,
    setPassword,
    setValidationStatus,
    onPasswordChange,
    otpData
}) => {
    const navigate = useNavigate()
    // @Soheil2026
    const { shouldSetPassword, canLoginWithPassword } = usePassword({ ...otpData?.data })
    const [showPassword, setShowPassword] = useState(false)
    const togglePassword = () => setShowPassword(prev => !prev)


    useEffect(() => {
        if (!otpData?.data) {
            navigate('/auth/signin')
        }
    }, [otpData])

    return (
        <div className='flex flex-col gap-2'>
            {
                shouldSetPassword &&
                <>
                    <div className='flex justify-between gap-1 items-center'>
                        <Label>
                            <Text tid={'code-sent_part-1'} />
                            <span className='text-xs text-main'>{" "} {inputValues.mobileOrEmail} {" "}</span>
                            <Text tid={'code-sent_part-2'} />
                        </Label>
                        <button
                            className='group py-2 text-xs sm:text-sm'
                            onClick={() => { navigate('/auth/signin') }}
                        >
                            <Text tid='edit-mobile/email' className='group-hover:text-active' />
                        </button>
                    </div>
                    <OTPInput
                        ref={otpInputRef}
                        value={verifyCode}
                        autoFocus={true}
                        onOtpChange={onVerifyCodeChange}
                    />
                    {timer > 0 ? (
                        <p className='flex items-center text-gray-500 text-sm'>
                            <Text tid='get-code' />
                            {' : '}
                            {timer}
                        </p>
                    ) : (
                        <p className='cursor-pointer hover:text-active text-sm' onClick={onOtpResend}>
                            <Text tid={'get-code'} />
                        </p>
                    )}
                </>
            }
            {verifyData?.data?.data?.authenticator && (
                <div className='flex flex-col gap-2 '>
                    <Label htmlFor='ga'>
                        <Text tid='google-verify' />
                    </Label>
                    <Input
                        id='ga'
                        status={
                            authCode.length === 0 ? 'normal' : authCode.length === 6 ? 'valid' : 'error'
                        }
                        maxLength={6}
                        onChange={(e) => setAuthCode(e?.target?.value)}
                        value={authCode}
                        autoFocus
                    />
                </div>
            )}
            {
                canLoginWithPassword &&
                <>
                    <div className='flex flex-col gap-2 mt-4'>
                        <Label >
                            <Text tid={"please-enter-your-password"} />
                        </Label>
                        <div className='relative '>
                            <Input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={e => onPasswordChange(e.target.value)}
                                placeholder="رمز عبور"
                            />
                            <button
                                type="button"
                                onClick={togglePassword}
                                className="absolute left-3 top-1/2 -translate-y-1/2 text-xs"
                            >
                                {showPassword ? <IoEye size={22} /> : <IoEyeOff size={22} />}
                            </button>
                        </div>
                        <Link to={'/auth/forget-password'} className='cursor-pointer  text-sm mt-2 mr-auto' >
                            <Text tid={'forget-password'} className='hover:text-active' />
                        </Link>
                    </div>
                </>
            }
            {shouldSetPassword && (
                <SetPasswordForm
                    setValidationStatus={setValidationStatus}
                    password={password}
                    onPasswordChange={setPassword}
                />
            )}
        </div>
    )
}

export default AuthOtpPage